<template>
  <div class="header">
    <!-- <div class="wp clearfix">
      <div class="btn-wp" v-if="!$store.state.isLogin">
        <span class="register-btn" @click="loginHandle" style="margin-right: 10px;font-size: 14px;">登陆</span>
        <span class="login-btn" @click="registerHandle({ status: true })" style="font-size: 14px;">
          注册
        </span>
      </div>
      <div class="btn-wp" v-else>
        <b>{{ $store.state.user.name }}</b>
        <el-button type="text" @click="logoutHandle" style="padding: 0"
          >退出</el-button
        >
      </div>
    </div> -->
    <el-dialog
      title="登陆"
      :visible.sync="$store.state.loginDialogStatus"
      :append-to-body="true"
      class="login-dialog"
    >
      <el-form :model="loginForm" :rules="rules" ref="loginForm">
        <el-form-item label="" prop="phone">
          <el-input
            v-model.number="loginForm.phone"
            autocomplete="off"
            prefix-icon="el-icon-mobile-phone"
          ></el-input>
        </el-form-item>
        <!-- <el-button type="primary" @click="submitForm">
          登录
        </el-button> -->
        <!-- <el-button
          type="text"
          @click="registerHandle({ status: true, isSimple: false })"
        >
          注册/登录
        </el-button> -->
      </el-form>
    </el-dialog>
    <el-dialog
      title="完善个人信息"
      :visible.sync="$store.state.registerDialogStatus"
      :append-to-body="true"
      class="register-dialog"
    >
      <el-form
        :model="registerForm"
        :rules="rules"
        ref="registerForm"
        label-width="80px"
        size="medium"
      >
        <el-form-item label="称呼" prop="name">
          <el-input
            v-model="registerForm.name"
            autocomplete="off"
            style="width: 100px; margin-right: 10px"
            type="text"
          ></el-input>
          <el-radio-group v-model="registerForm.gender">
            <el-radio label="先生"></el-radio>
            <el-radio label="女士"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="地址"
          prop="city"
          v-if="!$store.state.registerSimpleStatus"
        >
          <Location :focus="false"></Location>
        </el-form-item>

        <el-form-item
          label="所属行业"
          prop="industry"
          v-if="!$store.state.registerSimpleStatus"
        >
          <Industry placeholder="请选择行业"></Industry>
        </el-form-item>
        <el-form-item label="手机号码" prop="phone">
          <el-input
            v-model.number="registerForm.phone"
            autocomplete="off"
            placeholder="请输入手机号码"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input
            v-model.number="registerForm.code"
            autocomplete="off"
            placeholder="请输入验证码"
            style="width: 118px; margin-right: 8px;"
          ></el-input>
          <el-button
            type="primary"
            @click="getRegisterCode"
            style="width: 84px; margin-bottom: 0; padding-left:0; padding-right: 0;"
            :disabled="isSending"
          >
            <span v-if="isSending">{{ time }}(s)</span>
            <span v-else>获取验证码</span>
          </el-button>
        </el-form-item>
        <el-button type="primary" @click="submitRegisterForm">
          免费获取
        </el-button>
        <!-- <el-button type="text" @click="loginHandle(true)">
          注册/登录
        </el-button> -->
        <el-button type="text" @click="loginHandle(true)">
          <!--          <el-sl-panel style="font-size: 10px;color:red;">(注册即表示同意<a href="http://xianghaoming.com/agreement" target="_blank">用户隐私协议</a>)</el-sl-panel>-->
        </el-button>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import Location from "./Location";
import Industry from "./Industry";

export default {
  name: "Header",
  components: { Industry, Location },
  data() {
    const checkPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };

    const checkPhoneCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else if (!/^\d{6}$/.test(value)) {
        callback(new Error("请输6位验证码"));
      } else {
        callback();
      }
    };
    const checkCity = (rule, value, callback) => {
      if (!this.$store.state.location.c_id) {
        callback(new Error("请选择地址"));
      } else {
        callback();
      }
    };
    const checkIndustry = (rule, value, callback) => {
      if (!this.$store.state.industry.i_id) {
        callback(new Error("请选择行业"));
      } else {
        callback();
      }
    };
    return {
      submitFlag: false,
      activeIndex: "",
      loginForm: {
        phone: ""
      },
      registerForm: {
        name: "",
        gender: "先生",
        phone: "",
        code: ""
      },
      rules: {
        phone: [{ validator: checkPhone, required: true, trigger: "blur" }],
        name: [
          { required: true, message: "请输入您的称呼", trigger: "blur" },
          { max: 10, message: "最多输入 10 个字符", trigger: "blur" }
        ],
        city: [{ validator: checkCity, required: true, trigger: "change" }],
        industry: [
          { validator: checkIndustry, required: true, trigger: "change" }
        ],
        code: [{ validator: checkPhoneCode, required: true, trigger: "blur" }]
      },
      isSending: false,
      time: 60,
      timer: null
    };
  },
  computed: {},
  methods: {
    ...mapMutations([
      "setLoginDialogStatus",
      "setRegisterDialogStatus",
      "toggleLoginRegisterStatus",
      "logout"
    ]),
    ...mapActions(["sendSMS", "register", "validCode"]),
    handleSelect() {},
    submitForm() {
      // this.$refs.loginForm.validate(valid => {
      //   if (valid) {
      //     this.$store.dispatch("login", this.loginForm.phone).then(res => {
      //       if (res.data.status) {
      //         this.$message({
      //           type: "success",
      //           message: "登陆成功"
      //         });
      //         this.$store.commit("setLoginDialogStatus", false);
      //       } else {
      //         this.$message({
      //           type: "error",
      //           message: "手机号未注册，请注册后在登陆！"
      //         });
      //       }
      //     });
      //   } else {
      //     return false;
      //   }
      // });
      this.$refs.registerForm.validate(valid => {
        if (valid) {
          // const params = Object.assign({}, this.registerForm, {
          //   city: this.$store.state.location.c_id,
          //   sub_content: this.$route.meta.title,
          //   sub_button: "顶部-注册"
          // });
          let name = this.registerForm.name + this.registerForm.gender;
          this.validCode({
            phone: this.registerForm.phone,
            code: this.registerForm.code
          }).then(rescode => {
            if (rescode.data.code === 200) {
              this.submitFlag = true;
              this.register({
                name: name,
                phone: this.registerForm.phone,
                city_name: this.$store.state.location,
                detailsInfo: {},
                city_id: 1,
                share_phone: this.registerForm.phone,
                regInfo: {},
                check: this.$route.name === "check" ? 1 : null
              })
                .then(res => {
                  if (res.data.code === 200) {
                    this.$message({
                      type: "success",
                      message: "完善成功！"
                    });
                    this.$store.commit("setBossName", name);
                    this.$store.commit("setBossSex", this.registerForm.gender);
                    this.registerHandle({ status: false });
                    if (this.$route.name === "check") {
                      this.$store.commit("setCheckSelectDialogStatus", true);
                    } else {
                      this.$store.commit("setGiveNameDialogStatus", true);
                    }
                  } else {
                    this.$message({
                      type: "error",
                      message: res.data.result || "请稍后再试！"
                    });
                    this.registerForm.code = "";
                  }
                })
                .finally(() => {
                  this.submitFlag = false;
                });
            } else {
              this.$message({
                type: "error",
                message: rescode.data.message || "请稍后再试！"
              });
            }
          });
        }
      });
    },
    setSMSLockStart() {
      this.time = 60;
      this.isSending = true;
      clearTimeout(this.timer);
      this.timer = setInterval(() => {
        this.time--;
        if (this.time <= 0) {
          this.isSending = false;
        }
      }, 1000);
    },
    getRegisterCode() {
      this.$refs.registerForm.validateField("phone", error => {
        if (!error) {
          this.sendSMS(this.registerForm.phone).then(res => {
            if (res.status === 200) {
              this.$message({
                type: "success",
                message: res.data
              });
              this.setSMSLockStart();
            } else {
              this.$message({
                type: "error",
                message: res.data || "请稍后再试！"
              });
              this.isSending = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    submitRegisterForm() {
      this.$refs.registerForm.validate(valid => {
        if (valid) {
          // const params = Object.assign({}, this.registerForm, {
          //   city: this.$store.state.location.c_id,
          //   sub_content: this.$route.meta.title,
          //   sub_button: "顶部-注册"
          // });
          let name = this.registerForm.name + this.registerForm.gender;
          this.validCode({
            phone: this.registerForm.phone,
            code: this.registerForm.code
          }).then(rescode => {
            if (rescode.data.code === 200) {
              this.submitFlag = true;
              this.register({
                name: name,
                phone: this.registerForm.phone,
                city_name: this.$store.state.location,
                detailsInfo: {},
                city_id: 1,
                share_phone: this.registerForm.phone,
                regInfo: {},
                check: this.$route.name === "check" ? 1 : null
              })
                .then(res => {
                  if (res.data.code === 200) {
                    this.$message({
                      type: "success",
                      message: "完善成功！"
                    });
                    this.$store.commit("setBossName", name);
                    this.$store.commit("setBossSex", this.registerForm.gender);
                    this.registerHandle({ status: false });
                    if (this.$route.name === "check") {
                      this.$store.commit("setCheckSelectDialogStatus", true);
                    } else {
                      this.$store.commit("setGiveNameDialogStatus", true);
                    }
                  } else {
                    this.$message({
                      type: "error",
                      message: res.data.result || "请稍后再试！"
                    });
                    this.registerForm.code = "";
                  }
                })
                .finally(() => {
                  this.submitFlag = false;
                });
            } else {
              this.$message({
                type: "error",
                message: rescode.data.message || "请稍后再试！"
              });
            }
          });
        }
      });
    },
    loginHandle() {
      this.$refs.loginForm && this.$refs.loginForm.resetFields();
      this.setLoginDialogStatus(true);
    },
    logoutHandle() {
      this.logout();
    },
    registerHandle({ status, isSimple }) {
      this.$refs.registerForm && this.$refs.registerForm.resetFields();
      this.setRegisterDialogStatus({ status, isSimple });
    }
  },
  watch: {},
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
$height: 44px;
$color: rgba(255, 234, 0, 1);
.header {
  height: $height;
  position: relative;
  z-index: 3;
  box-sizing: border-box;
  padding: 0 13px 0 25px;
  .logo {
    float: left;
    img {
      width: 140px;
      height: 40px;
      margin: 10px 8px;
      vertical-align: middle;
    }
  }

  .header-nav {
    float: right;
    margin-right: 47px;
    a {
      padding: 0 10px;
      text-decoration: none;
      height: $height;
      line-height: $height;
      font-size: 14px;
      font-weight: bold;
      color: #fff;
      display: inline-block;
      vertical-align: top;
      /*box-sizing: border-box;*/
      &:first-of-type {
        margin-right: 34px;
      }
      &.is-active {
        color: $color;
        border-bottom: 3px solid $color;
      }
    }
  }
  .btn-wp {
    $navHeight: 24px;
    float: right;
    padding: ($height - $navHeight)/2 0;
    color: #fff;
    > span {
      width: 44px;
      height: $navHeight;
      line-height: $navHeight;
      border-radius: 3px;
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      cursor: pointer;
      font-size: 12px;
    }
    > span.login-btn {
      background: rgba(255, 234, 0, 1);
      color: #333;
      margin-right: 5px;
    }
    b {
      height: $navHeight;
      line-height: $navHeight;
      margin-right: 20px;
    }
  }
}
.login-dialog,
.register-dialog {
  .el-dialog {
    width: 370px;
    height: 250px;
  }

  .el-dialog__body {
    padding-top: 0;
  }
  .el-form {
    border-top: 1px solid #ddd;
    padding: 32px 0 0;
    .el-button {
      width: 100%;
      margin-bottom: 18px;
      margin-left: 0;
      &.el-button--text {
        padding: 0;
        margin: 0;
      }
    }
  }
}
.register-dialog {
  .el-dialog {
    width: 394px;
    height: auto;
  }
  .el-form {
    padding-top: 20px;
    .el-radio {
      margin-right: 10px;
    }
    .el-select {
      width: 100%;
    }
  }
  .el-radio-group {
    position: absolute;
    width: 120px;
    top: 12px;
  }
  .el-radio__label {
    padding-left: 5px;
  }
  .select-location,
  .select-industry {
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
  }
}
</style>
